import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import {
  ActiveCompanySubscription,
  NameFilter,
  StripeService,
} from '@ops/shared-types';
import { Observable, Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ops-active-projects-stats',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ops-active-projects-stats.component.html',
  styleUrl: './ops-active-projects-stats.component.scss',
})
export class OpsActiveProjectsStats implements OnChanges, OnDestroy {
  @Input() selectedCompanyId: string;

  stripeSubs: Subscription;
  activeCompanySubscription: ActiveCompanySubscription;
  isLoading: boolean = true;
  selectedCompany$: Observable<NameFilter>;

  constructor(private stripeService: StripeService) {
    // this.selectedCompany$ = this.sessionService.getUser$;
  }

  ngOnDestroy(): void {
    if (this.stripeSubs?.unsubscribe) {
      this.stripeSubs.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.stripeSubs?.unsubscribe) {
      this.stripeSubs.unsubscribe();
    }

    if (
      changes.selectedCompanyId?.previousValue !==
      changes.selectedCompanyId.currentValue
    ) {
      this.isLoading = true;
      this.stripeSubs = this.stripeService
        .getActiveCompoanySubscription()
        .subscribe((currentCompanySubscription: ActiveCompanySubscription) => {
          this.activeCompanySubscription = currentCompanySubscription;
          this.isLoading = false;
        });
    }
  }
}
